var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrowIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99904 11.2C7.53237 11.2 7.0657 11.0201 6.71237 10.6667L2.3657 6.32005C2.17237 6.12672 2.17237 5.80672 2.3657 5.61338C2.55904 5.42005 2.87904 5.42005 3.07237 5.61338L7.41904 9.96005C7.73904 10.2801 8.25904 10.2801 8.57904 9.96005L12.9257 5.61338C13.119 5.42005 13.439 5.42005 13.6324 5.61338C13.8257 5.80672 13.8257 6.12672 13.6324 6.32005L9.2857 10.6667C8.93237 11.0201 8.4657 11.2 7.99904 11.2Z",
    fill: "#050505",
    stroke: "#050505",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowIcon2);
export default __webpack_public_path__ + "static/media/downArrowIcon (2).5ad9cbbb5d38557ff1e07a47394dc111.svg";
export { ForwardRef as ReactComponent };